import MainLayoutPage from "./MainLayoutContainer";

export default MainLayoutPage;
